module.exports = __webpack_public_path__ + "media/warranty-claim/proof-doc-icon-04d2b20d.svg";